export default "__VITE_PUBLIC_ASSET__45b0b346__"